import { useEffect, useState } from "react";
import { adminGetOrders, adminUpdateOrderStatus, generateCertificateByItem } from "../../utils/api";

const STATUS_OPTIONS = ["нове", "в обробці", "відправлено", "доставлено", "скасовано"];

const statusClass = (s) => {
  const map = {
    нове: "нове",
    "в обробці": "вобробці",
    відправлено: "відправлено",
    доставлено: "доставлено",
    скасовано: "скасовано",
  };
  return map[s] || "";
};

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [filterStatus, setFilterStatus] = useState("всі");

  const load = () => {
    setLoading(true);
    adminGetOrders()
      .then((r) => setOrders(r.data.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await adminUpdateOrderStatus(orderId, newStatus);
      load();
      if (selected && selected.id === orderId) {
        setSelected((prev) => ({ ...prev, status: newStatus }));
      }
    } catch {
      alert("Помилка оновлення статусу");
    }
  };

  const filtered =
    filterStatus === "всі" ? orders : orders.filter((o) => o.status === filterStatus);

  return (
    <div>
      <div className="admin-header">
        <h1>Замовлення</h1>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {["всі", ...STATUS_OPTIONS].map((s) => (
            <button
              key={s}
              className={`admin-btn ${filterStatus === s ? "primary" : "secondary"}`}
              style={{ padding: "8px 16px", fontSize: "0.8rem" }}
              onClick={() => setFilterStatus(s)}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="spinner" />
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Покупець</th>
                <th>Телефон</th>
                <th>Сума</th>
                <th>Статус</th>
                <th>Дата</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td
                    colSpan={7}
                    style={{ textAlign: "center", padding: 40, color: "var(--text-light)" }}
                  >
                    Замовлень немає
                  </td>
                </tr>
              ) : (
                filtered.map((o) => {
                  const itemsTotal =
                    o.items?.reduce((sum, item) => {
                      return sum + Number(item.price) * Number(item.quantity);
                    }, 0) || 0;

                  const discount = Number(o.certificateDiscount || 0);
                  const final = Math.max(0, itemsTotal - discount);

                  return (
                    <tr key={o.id}>
                      <td>
                        <strong>#{o.id}</strong>
                      </td>

                      <td>{o.customerName}</td>
                      <td>{o.phone}</td>

                      <td>
                        <strong>{final.toFixed(0)} ₴</strong>
                      </td>

                      <td>
                        <span className={`status-badge status-${statusClass(o.status)}`}>
                          {o.status}
                        </span>
                      </td>

                      <td>{new Date(o.createdAt).toLocaleDateString("uk-UA")}</td>

                      <td>
                        <button
                          className="admin-btn secondary"
                          style={{ padding: "6px 14px", fontSize: "0.8rem" }}
                          onClick={() => setSelected(o)}
                        >
                          Деталі
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}

      {selected && (
        <div
          className="admin-modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) setSelected(null);
          }}
        >
          <div className="admin-modal" style={{ maxWidth: 680 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 24,
              }}
            >
              <h2>Замовлення #{selected.id}</h2>
              <button className="admin-btn secondary" onClick={() => setSelected(null)}>
                ✕
              </button>
            </div>

            <div
              style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 28 }}
            >
              {[
                { label: "Покупець", value: selected.customerName },
                { label: "Телефон", value: selected.phone },
                { label: "Email", value: selected.email || "—" },
                { label: "Дата", value: new Date(selected.createdAt).toLocaleString("uk-UA") },
              ].map((f) => (
                <div
                  key={f.label}
                  style={{ background: "var(--cream)", padding: 14, borderRadius: 10 }}
                >
                  <p style={{ fontSize: "0.72rem", color: "var(--text-light)" }}>{f.label}</p>
                  <p style={{ fontWeight: 600 }}>{f.value}</p>
                </div>
              ))}
            </div>

            <div
              style={{
                background: "var(--cream)",
                padding: 14,
                borderRadius: 10,
                marginBottom: 20,
              }}
            >
              <p style={{ fontSize: "0.72rem", color: "var(--text-light)" }}>Спосіб доставки</p>

              <p style={{ fontWeight: 500 }}>
                {selected.deliveryMethod === "nova" && "Нова Пошта"}
                {selected.deliveryMethod === "ukr" && "Укрпошта"}
                {selected.deliveryMethod === "pickup" && "Самовивіз"}
              </p>
            </div>

            <div
              style={{
                background: "var(--cream)",
                padding: 14,
                borderRadius: 10,
                marginBottom: 20,
              }}
            >
              <p style={{ fontSize: "0.72rem", color: "var(--text-light)" }}>Адреса доставки</p>
              <p style={{ fontWeight: 500 }}>{selected.address}</p>
            </div>

            <div
              style={{
                background: "var(--cream)",
                padding: 14,
                borderRadius: 10,
                marginBottom: 20,
              }}
            >
              <p style={{ fontSize: "0.72rem", color: "var(--text-light)" }}>Спосіб оплати</p>
              <p style={{ fontWeight: 500 }}>
                {selected.paymentMethod === "online" && "💳 Оплата на сайті"}
                {selected.paymentMethod === "prepayment" && "💰 Передоплата"}
                {selected.paymentMethod === "fop" && "🏦 Оплата на реквізити ФОП"}
              </p>
            </div>

            {selected.comment && (
              <div
                style={{
                  background: "var(--blush)",
                  padding: 14,
                  borderRadius: 10,
                  marginBottom: 20,
                }}
              >
                <p style={{ fontSize: "0.72rem", color: "var(--text-light)" }}>Коментар</p>
                <p>{selected.comment}</p>
              </div>
            )}

            {Number(selected.certificateDiscount) > 0 && (
              <div
                style={{
                  background: "var(--cream)",
                  padding: 14,
                  borderRadius: 10,
                  marginBottom: 20,
                }}
              >
                <p>
                  Код: <strong>{selected.certificateCode}</strong>
                </p>
                <p>
                  Знижка: <strong>{Number(selected.certificateDiscount).toFixed(0)} ₴</strong>
                </p>
              </div>
            )}

            {selected.items && selected.items.length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <p style={{ fontWeight: 600 }}>Товари</p>

                {selected.items.map((item) => (
                  <div key={item.id}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>
                        {item.type === "certificate"
                          ? `🎁 Сертифікат`
                          : item.product?.name || `Товар #${item.productId}`}
                      </span>

                      <span>
                        {item.price} ₴ × {item.quantity} = {console.log(item)}
                        {(Number(item.price) * item.quantity).toFixed(0)} ₴
                      </span>
                    </div>

                    <div style={{ fontSize: "0.8rem", color: "var(--text-light)" }}>
                      {item.size?.name && <span>Розмір: {item.size.name}</span>}
                      {item.texture?.name && <span> • Текстура: {item.texture.name}</span>}
                    </div>

                    {/* 🔥 КНОПКА ТОЛЬКО ДЛЯ СЕРТИФИКАТА */}
                    {item.type === "certificate" && !item.certificateCode && (
                      <button
                        className="admin-btn primary"
                        style={{ marginTop: 8, fontSize: "0.75rem" }}
                        onClick={async () => {
                          const res = await generateCertificateByItem(item.id);
                          // Оновлюємо тільки selected, без перезавантаження всіх замовлень
                          setSelected((prev) => ({
                            ...prev,
                            items: prev.items.map((i) =>
                              i.id === item.id
                                ? { ...i, certificateCode: res.data.data.codes.join(", ") }
                                : i
                            ),
                          }));
                          load(); // також оновлюємо таблицю фоново
                        }}
                      >
                        🎁 Згенерувати код сертифіката
                      </button>
                    )}

                    {/* если уже есть код */}
                    {item.type === "certificate" && item.certificateCode && (
                      <div style={{ marginTop: 6, color: "var(--terracotta)" }}>
                        Код: <strong>{item.certificateCode}</strong>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* TOTAL BLOCK FIXED */}
            <div style={{ borderTop: "2px solid var(--blush)", paddingTop: 16, marginBottom: 24 }}>
              {(() => {
                const itemsTotal =
                  selected.items?.reduce((sum, item) => {
                    return sum + Number(item.price) * Number(item.quantity);
                  }, 0) || 0;

                const discount = Number(selected.certificateDiscount || 0);
                const final = Math.max(0, itemsTotal - discount);

                return (
                  <>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Сума товарів:</span>
                      <span>{itemsTotal.toFixed(0)} ₴</span>
                    </div>

                    {discount > 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          color: "var(--terracotta)",
                        }}
                      >
                        <span>Знижка сертифікатом:</span>
                        <span>-{discount.toFixed(0)} ₴</span>
                      </div>
                    )}

                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
                      <strong>До сплати:</strong>
                      <strong>{final.toFixed(0)} ₴</strong>
                    </div>
                  </>
                );
              })()}
            </div>

            <div>
              <p>Змінити статус</p>

              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {STATUS_OPTIONS.map((s) => (
                  <button
                    key={s}
                    className={`admin-btn ${selected.status === s ? "primary" : "secondary"}`}
                    onClick={() => handleStatusChange(selected.id, s)}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
